function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var borderRadius = {
  "rnb-border-radius-circle": "50%",
  "rnb-border-radius-small": "0.25rem",
  "rnb-border-radius-medium": "0.5rem",
  "rnb-border-radius-large": "1rem",
  "rnb-border-radius-big": "1.25rem"
};
var borderWidth = {
  "rnb-border-width-thin": "1px",
  "rnb-border-width-thin-offset": "-1px",
  "rnb-border-width-default": "2px",
  "rnb-border-width-thick": "4px"
};
var black = "#000";
var blackRgb = "0, 0, 0";
var white = "#fff";
var whiteRgb = "255, 255, 255";
var midnight = "#263648";
var midnightRgb = "38, 54, 72";
var chill = "#0f81a3";
var chillRgb = "15, 129, 163";
var rose = "#bd2f2f";
var roseRgb = "189, 47, 47";
var lavender = "#d27df3";
var lavenderRgb = "210, 125, 243";
var sand = "#f69f4d";
var sandRgb = "246, 159, 77";
var dandelion = "#e9c627";
var dandelionRgb = "233, 198, 39";
var moss = "#add230";
var mossRgb = "173, 210, 48";
var sea = "#2cdb7b";
var seaRgb = "44, 219, 123";
var reef = "#2bcfc8";
var reefRgb = "43, 207, 200";
var salvia = "#9E86E7";
var salviaRgb = "158, 134, 231";
var sky = "#49C1E3";
var skyRgb = "73, 193, 227";
var core = {
  "rnb-colour-transparent": "transparent",
  "rnb-colour-black-tint-4": "#f5f5f5",
  "rnb-colour-black-tint-4-rgb": "245, 245, 245",
  "rnb-colour-black-alpha-4": "rgba(".concat(blackRgb, ", 0.04)"),
  "rnb-colour-black-alpha-8": "rgba(".concat(blackRgb, ", 0.08)"),
  "rnb-colour-black-alpha-16": "rgba(".concat(blackRgb, ", 0.16)"),
  "rnb-colour-black-alpha-32": "rgba(".concat(blackRgb, ", 0.32)"),
  "rnb-colour-black-alpha-64": "rgba(".concat(blackRgb, ", 0.64)"),
  "rnb-colour-black": black,
  "rnb-colour-black-rgb": blackRgb,
  "rnb-colour-white-alpha-4": "rgba(".concat(whiteRgb, ", 0.04)"),
  "rnb-colour-white-alpha-8": "rgba(".concat(whiteRgb, ", 0.08)"),
  "rnb-colour-white-alpha-16": "rgba(".concat(whiteRgb, ", 0.16)"),
  "rnb-colour-white-alpha-32": "rgba(".concat(whiteRgb, ", 0.32)"),
  "rnb-colour-white-alpha-48": "rgba(".concat(whiteRgb, ", 0.48)"),
  "rnb-colour-white-alpha-64": "rgba(".concat(whiteRgb, ", 0.64)"),
  "rnb-colour-white-alpha-80": "rgba(".concat(whiteRgb, ", 0.80)"),
  "rnb-colour-white": white,
  "rnb-colour-white-rgb": whiteRgb,
  "rnb-colour-midnight-tint-4": "#f7f7f8",
  "rnb-colour-midnight-tint-4-rgb": "247, 247, 248",
  "rnb-colour-midnight-tint-8": "#eeeff1",
  "rnb-colour-midnight-tint-8-rgb": "238, 239, 241",
  "rnb-colour-midnight-tint-16": "#dcdfe2",
  "rnb-colour-midnight-tint-16-rgb": "220, 223, 226",
  "rnb-colour-midnight-tint-32": "#b9bec4",
  "rnb-colour-midnight-tint-32-rgb": "185, 190, 196",
  "rnb-colour-midnight-tint-48": "#979fa8",
  "rnb-colour-midnight-tint-48-rgb": "151, 159, 168",
  "rnb-colour-midnight-tint-64": "#747f8a",
  "rnb-colour-midnight-tint-64-rgb": "116, 127, 138",
  "rnb-colour-midnight-tint-80": "#515E6D",
  "rnb-colour-midnight-tint-80-rgb": "81, 94, 109",
  "rnb-colour-midnight-alpha-96": "rgba(".concat(midnightRgb, ", 0.96)"),
  "rnb-colour-midnight": midnight,
  "rnb-colour-midnight-rgb": midnightRgb,
  "rnb-colour-midnight-shade-64": "#18232e",
  "rnb-colour-midnight-shade-64-rgb": "24, 35, 46",
  "rnb-colour-midnight-shade-48": "#121a23",
  "rnb-colour-midnight-shade-48-rgb": "18, 26, 35",
  "rnb-colour-midnight-shade-32": "#0c1117",
  "rnb-colour-midnight-shade-32-rgb": "12, 17, 23",
  "rnb-colour-chill-tint-4": "#f6fafc",
  "rnb-colour-chill-tint-4-rgb": "246, 250, 252",
  "rnb-colour-chill-tint-8": "#ecf5f8",
  "rnb-colour-chill-tint-8-rgb": "236, 245, 248",
  "rnb-colour-chill-tint-16": "#d8ebf0",
  "rnb-colour-chill-tint-16-rgb": "216, 235, 240",
  "rnb-colour-chill-tint-32": "#b2d6e1",
  "rnb-colour-chill-tint-32-rgb": "178, 214, 225",
  "rnb-colour-chill-tint-64": "#66aec5",
  "rnb-colour-chill-tint-64-rgb": "102, 174, 197",
  "rnb-colour-chill": chill,
  "rnb-colour-chill-rgb": chillRgb,
  "rnb-colour-chill-shade-64": "#0a5269",
  "rnb-colour-chill-shade-64-rgb": "10, 82, 105",
  "rnb-colour-chill-shade-48": "#073e4e",
  "rnb-colour-chill-shade-48-rgb": "7, 62, 78",
  "rnb-colour-chill-shade-32": "#052934",
  "rnb-colour-chill-shade-32-rgb": "5, 41, 52",
  "rnb-colour-rose-tint-8": "#faefef",
  "rnb-colour-rose-tint-8-rgb": "250, 239, 239",
  "rnb-colour-rose-tint-16": "#f4dede",
  "rnb-colour-rose-tint-16-rgb": "244, 222, 222",
  "rnb-colour-rose-tint-32": "#e9bcbc",
  "rnb-colour-rose-tint-32-rgb": "233, 188, 188",
  "rnb-colour-rose-tint-64": "#d57a7a",
  "rnb-colour-rose-tint-64-rgb": "213, 122, 122",
  "rnb-colour-rose": rose,
  "rnb-colour-rose-rgb": roseRgb,
  "rnb-colour-rose-shade-64": "#791e1e",
  "rnb-colour-rose-shade-64-rgb": "121, 30, 30",
  "rnb-colour-rose-shade-48": "#5b1717",
  "rnb-colour-rose-shade-48-rgb": "91, 23, 23",
  "rnb-colour-rose-shade-32": "#3c0f0f",
  "rnb-colour-rose-shade-32-rgb": "60, 15, 15",
  "rnb-colour-lavender-tint-8": "#fcf5fe",
  "rnb-colour-lavender-tint-8-rgb": "252, 245, 254",
  "rnb-colour-lavender-tint-16": "#f8eafd",
  "rnb-colour-lavender-tint-16-rgb": "248, 234, 253",
  "rnb-colour-lavender-tint-32": "#f0d5fb",
  "rnb-colour-lavender-tint-32-rgb": "240, 213, 251",
  "rnb-colour-lavender-tint-64": "#e2acf7",
  "rnb-colour-lavender-tint-64-rgb": "226, 172, 247",
  "rnb-colour-lavender": lavender,
  "rnb-colour-lavender-rgb": lavenderRgb,
  "rnb-colour-lavender-shade-64": "#86509b",
  "rnb-colour-lavender-shade-64-rgb": "134, 80, 155",
  "rnb-colour-lavender-shade-48": "#653c75",
  "rnb-colour-lavender-shade-48-rgb": "101, 60, 117",
  "rnb-colour-lavender-shade-32": "#43284e",
  "rnb-colour-lavender-shade-32-rgb": "67, 40, 78",
  "rnb-colour-sand-tint-8": "#fff8f1",
  "rnb-colour-sand-tint-8-rgb": "255, 248, 241",
  "rnb-colour-sand-tint-16": "#fdefe2",
  "rnb-colour-sand-tint-16-rgb": "253, 239, 226",
  "rnb-colour-sand-tint-32": "#fce0c6",
  "rnb-colour-sand-tint-32-rgb": "252, 224, 198",
  "rnb-colour-sand-tint-64": "#f9c28d",
  "rnb-colour-sand-tint-64-rgb": "249, 194, 141",
  "rnb-colour-sand": sand,
  "rnb-colour-sand-rgb": sandRgb,
  "rnb-colour-sand-shade-64": "#9d6631",
  "rnb-colour-sand-shade-64-rgb": "157, 102, 49",
  "rnb-colour-sand-shade-48": "#764c25",
  "rnb-colour-sand-shade-48-rgb": "118, 76, 37",
  "rnb-colour-sand-shade-32": "#4f3319",
  "rnb-colour-sand-shade-32-rgb": "79, 51, 25",
  "rnb-colour-dandelion-tint-8": "#fefbee",
  "rnb-colour-dandelion-tint-8-rgb": "254, 251, 238",
  "rnb-colour-dandelion-tint-16": "#fbf6dc",
  "rnb-colour-dandelion-tint-16-rgb": "251, 246, 220",
  "rnb-colour-dandelion-tint-32": "#f8ecb9",
  "rnb-colour-dandelion-tint-32-rgb": "248, 236, 185",
  "rnb-colour-dandelion-tint-64": "#f1db75",
  "rnb-colour-dandelion-tint-64-rgb": "41, 219, 117",
  "rnb-colour-dandelion": dandelion,
  "rnb-colour-dandelion-rgb": dandelionRgb,
  "rnb-colour-dandelion-shade-64": "#957f19",
  "rnb-colour-dandelion-shade-64-rgb": "149, 127, 25",
  "rnb-colour-dandelion-shade-48": "#705f13",
  "rnb-colour-dandelion-shade-48-rgb": "112, 95, 19",
  "rnb-colour-dandelion-shade-32": "#4b3f0c",
  "rnb-colour-dandelion-shade-32-rgb": "75, 63, 12",
  "rnb-colour-moss-tint-8": "#f8fbee",
  "rnb-colour-moss-tint-8-rgb": "248, 251, 238",
  "rnb-colour-moss-tint-16": "#f2f8de",
  "rnb-colour-moss-tint-16-rgb": "242, 248, 222",
  "rnb-colour-moss-tint-32": "#e4f0bc",
  "rnb-colour-moss-tint-32-rgb": "228, 240, 188",
  "rnb-colour-moss-tint-64": "#cbe27b",
  "rnb-colour-moss-tint-64-rgb": "203, 226, 123",
  "rnb-colour-moss": moss,
  "rnb-colour-moss-rgb": mossRgb,
  "rnb-colour-moss-shade-64": "#6f861f",
  "rnb-colour-moss-shade-64-rgb": "111, 134, 3",
  "rnb-colour-moss-shade-48": "#536517",
  "rnb-colour-moss-shade-48-rgb": "83, 101, 23",
  "rnb-colour-moss-shade-32": "#37430f",
  "rnb-colour-moss-shade-32-rgb": "55, 67, 15",
  "rnb-colour-sea-tint-8": "#effdf5",
  "rnb-colour-sea-tint-8-rgb": "#239, 253, 245",
  "rnb-colour-sea-tint-16": "#ddf9ea",
  "rnb-colour-sea-tint-16-rgb": "221, 249, 234",
  "rnb-colour-sea-tint-32": "#bbf3d4",
  "rnb-colour-sea-tint-32-rgb": "187, 243, 212",
  "rnb-colour-sea-tint-64": "#78e8ab",
  "rnb-colour-sea-tint-64-rgb": "120, 232, 171",
  "rnb-colour-sea": sea,
  "rnb-colour-sea-rgb": seaRgb,
  "rnb-colour-sea-shade-64": "#1c8c4f",
  "rnb-colour-sea-shade-64-rgb": "28, 140, 79",
  "rnb-colour-sea-shade-48": "#15693b",
  "rnb-colour-sea-shade-48-rgb": "21, 105, 59",
  "rnb-colour-sea-shade-32": "#0e4627",
  "rnb-colour-sea-shade-32-rgb": "14, 70, 39",
  "rnb-colour-reef-tint-8": "#effcfb",
  "rnb-colour-reef-tint-8-rgb": "239, 252, 25",
  "rnb-colour-reef-tint-16": "#ddf8f7",
  "rnb-colour-reef-tint-16-rgb": "221, 248, 247",
  "rnb-colour-reef-tint-32": "#bbf0ee",
  "rnb-colour-reef-tint-32-rgb": "187, 240, 238",
  "rnb-colour-reef-tint-64": "#78e1dc",
  "rnb-colour-reef-tint-64-rgb": "120, 225, 220",
  "rnb-colour-reef": reef,
  "rnb-colour-reef-rgb": reefRgb,
  "rnb-colour-reef-shade-64": "#1c8580",
  "rnb-colour-reef-shade-64-rgb": "28, 133, 128",
  "rnb-colour-reef-shade-48": "#156460",
  "rnb-colour-reef-shade-48-rgb": "21, 100, 96",
  "rnb-colour-reef-shade-32": "#0e4341",
  "rnb-colour-reef-shade-32-rgb": "14, 67, 65",
  "rnb-colour-salvia": salvia,
  "rnb-colour-salvia-rgb": salviaRgb,
  "rnb-colour-salvia-shade-32": "#332B4A",
  "rnb-colour-salvia-shade-32-rgb": "51, 43, 74",
  "rnb-colour-salvia-shade-48": "#4C406F",
  "rnb-colour-salvia-shade-48-rgb": "76, 64, 111",
  "rnb-colour-salvia-shade-64": "#655694",
  "rnb-colour-salvia-shade-64-rgb": "101, 86, 148",
  "rnb-colour-salvia-tint-8": "#F7F5FD",
  "rnb-colour-salvia-tint-8-rgb": "247, 245, 253",
  "rnb-colour-salvia-tint-16": "#EFECFB",
  "rnb-colour-salvia-tint-16-rgb": "239, 236, 251",
  "rnb-colour-salvia-tint-32": "#E0D8F7",
  "rnb-colour-salvia-tint-32-rgb": "224, 216, 247",
  "rnb-colour-salvia-tint-64": "#C1B2F0",
  "rnb-colour-salvia-tint-64-rgb": "193, 178, 240",
  "rnb-colour-sky": sky,
  "rnb-colour-sky-rgb": skyRgb,
  "rnb-colour-sky-shade-32": "#173E49",
  "rnb-colour-sky-shade-32-rgb": "23, 62, 73",
  "rnb-colour-sky-shade-48": "#235D6D",
  "rnb-colour-sky-shade-48-rgb": "35, 93, 109",
  "rnb-colour-sky-shade-64": "#2F7C91",
  "rnb-colour-sky-shade-64-rgb": "47, 124, 145",
  "rnb-colour-sky-tint-8": "#F0FAFD",
  "rnb-colour-sky-tint-8-rgb": "240, 250, 253",
  "rnb-colour-sky-tint-16": "#E2F5FB",
  "rnb-colour-sky-tint-16-rgb": "225, 245, 251",
  "rnb-colour-sky-tint-32": "#C5EBF6",
  "rnb-colour-sky-tint-32-rgb": "197, 235, 246",
  "rnb-colour-sky-tint-64": "#8AD8ED",
  "rnb-colour-sky-tint-64-rgb": "138, 216, 237",
  "rnb-colour-grad-shade-a": "#1A2430",
  "rnb-colour-grad-shade-a-rgb": "26, 36, 48, 1",
  "rnb-colour-grad-shade-tint": "#3E3837",
  "rnb-colour-grad-shade-tint-rgb": "62, 56, 55, 1",
  "rnb-colour-grad-shade-b": "#C46466",
  "rnb-colour-grad-shade-b-rgb": "196, 100, 102, 1"
};
var defaults = {
  "rnb-colour-band-theta": core["rnb-colour-sand-tint-64"],
  "rnb-colour-band-alpha": core["rnb-colour-sand-tint-64"],
  "rnb-colour-band-beta": core["rnb-colour-dandelion-tint-64"],
  "rnb-colour-band-gamma": core["rnb-colour-moss-tint-64"],
  "rnb-colour-band-delta": core["rnb-colour-sea-tint-64"],
  "rnb-colour-band-epsilon": core["rnb-colour-chill-tint-32"],
  "rnb-colour-primary-light": core["rnb-colour-midnight"],
  "rnb-colour-primary-inverted-light": core["rnb-colour-white"],
  "rnb-colour-primary-light-rgb": core["rnb-colour-midnight-rgb"],
  "rnb-colour-secondary-light": core["rnb-colour-midnight-tint-64"],
  "rnb-colour-secondary-light-rgb": core["rnb-colour-midnight-tint-64-rgb"],
  "rnb-colour-tertiary-light": core["rnb-colour-midnight-tint-48"],
  "rnb-colour-tertiary-light-rgb": core["rnb-colour-midnight-tint-48-rgb"],
  "rnb-colour-positive-light": core["rnb-colour-sea-shade-64"],
  "rnb-colour-positive-light-rgb": core["rnb-colour-sea-shade-64-rgb"],
  "rnb-colour-negative-light": core["rnb-colour-rose"],
  "rnb-colour-negative-light-rgb": core["rnb-colour-rose-rgb"],
  "rnb-colour-attention-light": core["rnb-colour-sand"],
  "rnb-colour-attention-light-rgb": core["rnb-colour-sand-rgb"],
  "rnb-colour-disabled-light": core["rnb-colour-midnight-tint-16"],
  "rnb-colour-disabled-light-rgb": core["rnb-colour-midnight-tint-16-rgb"],
  "rnb-colour-action-light": core["rnb-colour-chill"],
  "rnb-colour-action-light-rgb": core["rnb-colour-chill-rgb"],
  "rnb-colour-action-hover-light": core["rnb-colour-chill-shade-64"],
  "rnb-colour-overlay-light": core["rnb-colour-midnight-alpha-96"],
  "rnb-colour-background-light": core["rnb-colour-midnight-tint-4"],
  "rnb-colour-card-light": core["rnb-colour-white"],
  "rnb-colour-cell-light": core["rnb-colour-white"],
  "rnb-colour-section-light": core["rnb-colour-white"],
  "rnb-colour-header-light": core["rnb-colour-white"],
  "rnb-colour-footer-light": core["rnb-colour-midnight-shade-64"],
  "rnb-colour-primary-dark": core["rnb-colour-white"],
  "rnb-colour-primary-inverted-dark": core["rnb-colour-midnight"],
  "rnb-colour-secondary-dark": core["rnb-colour-white-alpha-64"],
  "rnb-colour-tertiary-dark": core["rnb-colour-white-alpha-48"],
  "rnb-colour-positive-dark": core["rnb-colour-sea"],
  "rnb-colour-negative-dark": core["rnb-colour-rose-tint-64"],
  "rnb-colour-attention-dark": core["rnb-colour-sand"],
  "rnb-colour-disabled-dark": core["rnb-colour-white-alpha-16"],
  "rnb-colour-action-dark": core["rnb-colour-white"],
  "rnb-colour-action-hover-dark": core["rnb-colour-white-alpha-64"],
  "rnb-colour-overlay-dark": core["rnb-colour-black-alpha-64"],
  "rnb-colour-background-dark": core["rnb-colour-midnight-shade-32"],
  "rnb-colour-card-dark": core["rnb-colour-midnight-shade-64"],
  "rnb-colour-cell-dark": core["rnb-colour-white-alpha-4"],
  "rnb-colour-section-dark": core["rnb-colour-white-alpha-4"],
  "rnb-colour-header-dark": core["rnb-colour-white-alpha-4"],
  "rnb-colour-footer-dark": core["rnb-colour-white-alpha-4"]
};
var colour = __spreadValues(__spreadValues({}, core), defaults);
var fontFamily = {
  "rnb-font-family-cs-clarity": "CSClarity, Helvetica Neue, Helvetica, Arial, sans-serif"
};
var fontSize = {
  "rnb-font-size-micro": "0.625rem",
  "rnb-font-size-tiny": "0.75rem",
  "rnb-font-size-mini": "0.875rem",
  "rnb-font-size-small": "1rem",
  "rnb-font-size-medium": "1.25rem",
  "rnb-font-size-large": "1.5rem",
  "rnb-font-size-big": "2rem",
  "rnb-font-size-huge": "2.5rem",
  "rnb-font-size-massive": "2.75rem",
  "rnb-font-size-jumbo": "4rem",
  "rnb-font-size-gargantuan": "6rem",
  "rnb-font-size-ridiculous": "8rem"
};
var fontWeight = {
  "rnb-font-weight-thin": 100,
  "rnb-font-weight-light": 200,
  "rnb-font-weight-book": 300,
  "rnb-font-weight-regular": 400,
  "rnb-font-weight-medium": 500,
  "rnb-font-weight-bold": 700,
  "rnb-font-weight-black": 900
};
var lineHeight = {
  "rnb-line-height-reset": "1",
  "rnb-line-height-text": "1.5",
  "rnb-line-height-heading": "1.2"
};
var small = 375;
var phablet = 512;
var medium = 768;
var large = 1024;
var huge = 1408;
var mediaQuery = {
  "rnb-mq-small": "(min-width: ".concat(small, "px)"),
  "rnb-mq-phablet": "(min-width: ".concat(phablet, "px)"),
  "rnb-mq-medium": "(min-width: ".concat(medium, "px)"),
  "rnb-mq-lt-medium": "(max-width: ".concat(medium - 1, "px)"),
  "rnb-mq-large": "(min-width: ".concat(large, "px)"),
  "rnb-mq-huge": "(min-width: ".concat(huge, "px)")
};
var shadow = {
  "rnb-shadow-sea": "0 0 0 ".concat(colour["rnb-colour-transparent"]),
  "rnb-shadow-earth": "0 0.125rem 0.25rem ".concat(colour["rnb-colour-black-alpha-16"]),
  "rnb-shadow-hill": "0 0.25rem 0.5rem ".concat(colour["rnb-colour-black-alpha-16"]),
  "rnb-shadow-mountain": "0 0.5rem 0.75rem ".concat(colour["rnb-colour-black-alpha-16"]),
  "rnb-shadow-hill-light": "0 0 0.75rem  ".concat(colour["rnb-colour-black-alpha-4"], ", 0 0.4rem 0.75rem  ").concat(colour["rnb-colour-black-alpha-8"]),
  "rnb-shadow-earth-top": "0 -0.125rem 0.25rem ".concat(colour["rnb-colour-black-alpha-16"]),
  "rnb-shadow-hill-top": "0 -0.25rem 0.5rem ".concat(colour["rnb-colour-black-alpha-16"]),
  "rnb-shadow-mountain-top": "0 -0.5rem 0.75rem ".concat(colour["rnb-colour-black-alpha-16"])
};
var spacing = {
  "rnb-spacing-none": "0rem",
  "rnb-spacing-micro": "0.25rem",
  "rnb-spacing-tiny": "0.5rem",
  "rnb-spacing-small": "0.75rem",
  "rnb-spacing-medium": "1rem",
  "rnb-spacing-large": "1.5rem",
  "rnb-spacing-big": "2rem",
  "rnb-spacing-huge": "3rem",
  "rnb-spacing-super": "4rem",
  "rnb-spacing-jumbo": "8rem"
};
var spacing$1 = __spreadProps(__spreadValues({}, spacing), {
  "rnb-spacing-inset-squash-micro": "".concat(spacing["rnb-spacing-micro"], " ").concat(spacing["rnb-spacing-tiny"]),
  "rnb-spacing-inset-squash-tiny": "".concat(spacing["rnb-spacing-tiny"], " ").concat(spacing["rnb-spacing-small"]),
  "rnb-spacing-inset-squash-small": "".concat(spacing["rnb-spacing-small"], " ").concat(spacing["rnb-spacing-medium"]),
  "rnb-spacing-inset-squash-medium": "".concat(spacing["rnb-spacing-medium"], " ").concat(spacing["rnb-spacing-large"]),
  "rnb-spacing-inset-squeeze-micro": "".concat(spacing["rnb-spacing-tiny"], " ").concat(spacing["rnb-spacing-micro"]),
  "rnb-spacing-inset-squeeze-tiny": "".concat(spacing["rnb-spacing-small"], " ").concat(spacing["rnb-spacing-tiny"]),
  "rnb-spacing-inset-squeeze-medium": "".concat(spacing["rnb-spacing-large"], " ").concat(spacing["rnb-spacing-medium"])
});
var timing = {
  "rnb-timing-fast": "250ms",
  "rnb-timing-normal": "500ms",
  "rnb-timing-slow": "1000ms",
  "rnb-timing-easing-in": "cubic-bezier(0.4, 0, 1, 1)"
};
var zIndex = {
  "rnb-zindex-dive": -200,
  "rnb-zindex-default": 1,
  "rnb-zindex-levitate": 2,
  "rnb-zindex-rise": 200,
  "rnb-zindex-sky": 400,
  "rnb-zindex-top": 600
};
var gradient = {
  "rnb-gradient-exclusive": "linear-gradient(-180deg, ".concat(colour["rnb-colour-midnight"], ", ").concat(colour["rnb-colour-midnight-shade-64"], ")")
};
export { borderRadius, borderWidth, colour, fontFamily, fontSize, fontWeight, gradient, lineHeight, mediaQuery, shadow, spacing$1 as spacing, timing, zIndex };